import { render } from "./ModelForm.vue?vue&type=template&id=53689b21"
import script from "./ModelForm.vue?vue&type=script&lang=js"
export * from "./ModelForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__